// Application settings and configuration

const API_BASE_URL = (
  process.env.REACT_APP_API_URL || "http://localhost:8000/api"
).replace(/\/$/, "");

const MEDIA_BASE_URL = (
  process.env.REACT_APP_MEDIA_BASE_URL ||
  API_BASE_URL.replace(/\/api$/, "") ||
  "http://localhost:8000"
).replace(/\/$/, "");

export const settings = {
  // API Configuration
  API_BASE_URL,

  // Backend origin for /media/ and other relative file paths
  MEDIA_BASE_URL,

  // Development settings
  DEBUG: process.env.REACT_APP_DEBUG === "true",
  MOCK_API: process.env.REACT_APP_MOCK_API === "true",

  // App settings
  APP_NAME: "Customer Care System",
  APP_VERSION: "1.0.0",

  // Language settings
  DEFAULT_LANGUAGE: "ar",
  SUPPORTED_LANGUAGES: ["ar", "en"],

  // Theme settings (site_style: default | blue | green | purple | dark)
  DEFAULT_SITE_STYLE: "default",

  // Local storage keys
  STORAGE_KEYS: {
    AUTH_TOKEN: "authToken",
    USER_DATA: "userData",
    USER_PERMISSIONS: "userPermissions",
    PENDING_TICKET_REDIRECT: "pendingTicketRedirect",
    LANGUAGE: "language",
    THEME: "theme",
  },

  // API endpoints
  ENDPOINTS: {
    AUTH: {
      LOGIN: "/auth/login/",
      LOGOUT: "/auth/logout/",
      REFRESH: "/auth/refresh/",
      PROFILE: "/auth/profile/",
    },
    TICKETS: {
      LIST: "/tickets/",
      CREATE: "/tickets/",
      DETAIL: "/tickets/:id/",
      UPDATE: "/tickets/:id/",
      DELETE: "/tickets/:id/",
    },
    CUSTOMERS: {
      LIST: "/customers/",
      CREATE: "/customers/",
      DETAIL: "/customers/:id/",
      UPDATE: "/customers/:id/",
      DELETE: "/customers/:id/",
    },
    REPORTS: {
      DASHBOARD: "/reports/dashboard/",
    },
  },

  // Validation rules
  VALIDATION: {
    EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    PASSWORD_MIN_LENGTH: 6,
    NAME_MIN_LENGTH: 2,
    PHONE_REGEX: /^[\+]?[1-9][\d]{0,15}$/,
  },

  // UI settings
  UI: {
    SIDEBAR_WIDTH: 240,
    HEADER_HEIGHT: 64,
    DRAWER_WIDTH: 240,
    ANIMATION_DURATION: 300,
  },

  // Pagination
  PAGINATION: {
    DEFAULT_PAGE_SIZE: 10,
    PAGE_SIZE_OPTIONS: [10, 25, 50, 100],
  },

  // Date formats
  DATE_FORMATS: {
    DISPLAY: "DD/MM/YYYY",
    API: "YYYY-MM-DD",
    DATETIME: "DD/MM/YYYY HH:mm",
  },
};

export default settings;
